import { Component } from '@angular/core';
import { I18nKeys } from '../../shared/models/i18n.model';

@Component({
	selector: 'app-success',
	standalone: false,
	templateUrl: './success.html',
	styleUrl: './success.scss',
})
export class Success {
	protected readonly I18N = I18nKeys;
}
